// src/api/config.ts

/**
 * Shared API configuration for the Quantik Mind enterprise frontend.
 *
 * This module centralizes:
 * - the resolved backend base URL
 * - default client timeout values
 * - a helper for building authenticated JSON headers
 */

export const API_CONFIG = {
  /**
   * Backend base URL resolved from the React environment.
   *
   * A local default is preserved for development environments when no explicit
   * environment variable is provided.
   */
  BASE_URL: (
    process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1'
  )
    .trim()
    .replace(/\/$/, ''),

  /**
   * Default API timeout value in milliseconds.
   */
  TIMEOUT: 30000,
};

/**
 * Build JSON request headers with an optional bearer token.
 *
 * @param token - Optional authentication token.
 * @returns Standard JSON headers for authenticated API requests.
 */
export const getAuthHeaders = (token?: string) => ({
  'Content-Type': 'application/json',
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

